import Swal, { SweetAlertIcon, SweetAlertResult } from 'sweetalert2';

const DEFAULT_CONFIRM_COLOR = '#00cfcf';
const DANGER_CONFIRM_COLOR = '#d33';

export const AlertUtils = {
  /**
   * Displays a standard alert with a specified icon.
   */
  show: (title: string, text: string, icon: SweetAlertIcon = 'info') => {
    return Swal.fire({
      title,
      text,
      icon,
      confirmButtonColor: DEFAULT_CONFIRM_COLOR,
    });
  },

  /**
   * Displays a success alert.
   */
  success: (title: string, text?: string) => {
    return AlertUtils.show(title, text || '', 'success');
  },

  /**
   * Displays an error alert.
   */
  error: (title: string, text?: string) => {
    return AlertUtils.show(title, text || '', 'error');
  },

  /**
   * Displays a warning alert.
   */
  warning: (title: string, text?: string) => {
    return AlertUtils.show(title, text || '', 'warning');
  },

  /**
   * Displays a confirmation dialog (e.g., before deleting).
   */
  confirm: (
    title: string,
    text: string,
    confirmButtonText: string = 'Yes',
    isDanger: boolean = false
  ): Promise<SweetAlertResult<any>> => {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: isDanger ? DANGER_CONFIRM_COLOR : DEFAULT_CONFIRM_COLOR,
      cancelButtonColor: '#aaa',
      confirmButtonText,
    });
  },

  /**
   * Shows a loading spinner alert.
   */
  loading: (title: string = 'Loading...') => {
    Swal.fire({
      title,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  },

  /**
   * Closes any currently open alert.
   */
  close: () => {
    Swal.close();
  },
};
